(function () {
  'use strict';

  /* ---------- header: solid once the page moves ---------- */
  var header = document.querySelector('.nx-header');
  if (header) {
    var solidify = function () {
      header.classList.toggle('is-solid', window.scrollY > 24);
    };
    solidify();
    window.addEventListener('scroll', solidify, { passive: true });
  }

  /* a hero that carries the wordmark tells the header to stay bare */
  var heroEl = document.querySelector('.nx-hero[data-defer-header-mark="true"]');
  if (heroEl && header) header.setAttribute('data-defer-mark', 'true');

  /* ---------- mobile drawer ---------- */
  var drawer = document.querySelector('[data-nx-drawer]');
  var openBtn = document.querySelector('[data-nx-menu-open]');
  var closeBtn = document.querySelector('[data-nx-menu-close]');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.setAttribute('data-open', open ? 'true' : 'false');
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) {
      var first = drawer.querySelector('a');
      if (first) first.focus();
    } else if (openBtn) {
      openBtn.focus();
    }
  }

  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === 'true') setDrawer(false);
  });

  /* ---------- shop category filter ---------- */
  var shop = document.querySelector('[data-nx-shop]');
  if (shop) {
    var buttons = shop.querySelectorAll('[data-nx-filter]');
    var cards = shop.querySelectorAll('.nx-card');
    var none = shop.querySelector('[data-nx-noresults]');

    var apply = function (want) {
      var visible = 0;
      cards.forEach(function (card) {
        var match = want === 'all' || card.getAttribute('data-cat') === want;
        card.hidden = !match;
        if (match) visible++;
      });
      if (none) none.hidden = visible !== 0;
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-nx-filter') === want ? 'true' : 'false');
      });
      if (history.replaceState) {
        history.replaceState(null, '', want === 'all' ? location.pathname : location.pathname + '#' + want);
      }
    };

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-nx-filter')); });
    });

    var fromHash = (location.hash || '').replace('#', '');
    if (fromHash && shop.querySelector('[data-nx-filter="' + fromHash + '"]')) apply(fromHash);
  }

  /* ---------- product: size selection ---------- */
  var sizes = document.querySelector('[data-nx-sizes]');
  if (sizes) {
    var input = document.querySelector('[data-nx-variant-input]');
    var priceEl = document.querySelector('[data-nx-price]');
    var label = document.querySelector('[data-nx-size-label]');

    sizes.querySelectorAll('[data-nx-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;
        sizes.querySelectorAll('[data-nx-variant]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        btn.setAttribute('aria-pressed', 'true');
        if (input) input.value = btn.getAttribute('data-nx-variant');
        if (priceEl) priceEl.textContent = btn.getAttribute('data-price');
        if (label) label.textContent = btn.getAttribute('data-title');
      });
    });
  }


  /* ---------- mock pieces: one page, hash-routed ---------- */
  var pieces = document.querySelectorAll('.nx-piece');
  if (pieces.length) {
    var showPiece = function () {
      var want = (location.hash || '').replace('#', '');
      var matched = false;
      pieces.forEach(function (el) {
        var hit = el.getAttribute('data-piece') === want;
        el.hidden = !hit;
        if (hit) matched = true;
      });
      if (!matched) pieces[0].hidden = false;
      window.scrollTo({ top: 0, behavior: 'auto' });
    };
    showPiece();
    window.addEventListener('hashchange', showPiece);

    document.addEventListener('click', function (e) {
      var size = e.target.closest('[data-nx-mocksize]');
      if (size) {
        var row = size.parentNode;
        row.querySelectorAll('[data-nx-mocksize]').forEach(function (b) {
          b.setAttribute('aria-pressed', 'false');
        });
        size.setAttribute('aria-pressed', 'true');
        return;
      }
      var add = e.target.closest('[data-nx-mockadd]');
      if (add) {
        var note = add.closest('div').querySelector('[data-nx-mocknote]');
        if (note) note.hidden = false;
      }
    });
  }

  /* ---------- contact form: double-submit guard ----------
     Nothing is intercepted here. The submit runs as Shopify's own form post,
     so its spam check wraps the submission exactly as it expects to — an
     earlier version posted via fetch and, when that was not recognised as a
     success, re-posted with form.submit(). That call skips the spam check's
     own handler, so Shopify rejected the raw post and left the visitor on
     /contact, which is POST-only and answers GET with a 404.

     All that is left is the part that cannot affect delivery: once the post is
     under way the button stops accepting further presses and says so. */
  var contactForms = document.querySelectorAll('form[data-nx-contact]');
  Array.prototype.forEach.call(contactForms, function (form) {
    var btn = form.querySelector('[data-nx-submit]');
    if (!btn) return;

    form.addEventListener('submit', function () {
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
      // Deferred: disabling a submit button inside its own submit handler can
      // cancel the submission in some browsers.
      setTimeout(function () {
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = btn.getAttribute('data-sending') || 'Sending';
      }, 0);
    });
  });

  /* ---------- reveal on scroll ---------- */
  var risers = document.querySelectorAll('.nx-rise');
  if (!risers.length) return;

  if (!('IntersectionObserver' in window)) {
    risers.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });

  risers.forEach(function (el) { io.observe(el); });
})();
